<template>
  <div>
    <a
      @click="$router.push({ name: 'staff-transactions' })"

    >
      <feather-icon icon="ChevronLeftIcon" class="cursor-pointer align-bottom"/>Back to list
    </a>
    <vx-card class="mt-5 lg:p-5 md:p5 p-3 trans-page">
      <h4 class="font-bold">Payment request details</h4>
      <vs-row class="flex-wrap justify-between">
        <vs-col vs-w="4" vs-lg="4" vs-md="3" vs-sm="5" vs-xs="12">
          <div class="flex flex-wrap items-center justify-between wrap-span">
            <label class="lg:w-1/2 md:w-auto w-max">Customer name</label>
            <span class="font-bold lg:w-1/2 md:w-auto w-max">{{ paymentRequestDetail.payeeName }}</span>
          </div>
          <div class="flex flex-wrap items-center justify-between wrap-span">
            <label class="lg:w-1/2 md:w-auto w-max">Customer mobile</label>
            <span class="font-bold lg:w-1/2 md:w-auto w-max">{{ paymentRequestDetail.payeePhone | phoneNumber}}</span>
          </div>
          <div class="flex flex-wrap items-center justify-between wrap-span">
            <label class="lg:w-1/2 md:w-auto w-max">Customer email</label>
            <span class="font-bold lg:w-1/2 md:w-auto w-max"><a :href="`mailto:${paymentRequestDetail.payeeEmail}`">{{ paymentRequestDetail.payeeEmail }}</a></span>
          </div>
        </vs-col>
        <vs-col class="lg:mx-4 md:mx-4" vs-w="4" vs-lg="4" vs-md="3" vs-sm="5" vs-xs="12">
          <div class="flex flex-wrap items-center justify-between wrap-span">
            <label class="lg:w-1/2 md:w-auto w-max">Your reference</label>
            <span class="font-bold lg:w-1/2 md:w-auto w-max">
              {{ paymentRequestDetail.reference }}
            </span>
          </div>
          <div class="flex flex-wrap items-center justify-between wrap-span">
            <label class="lg:w-1/2 md:w-auto w-max">Amount</label>
            <span class="font-bold lg:w-1/2 md:w-auto w-max">
              {{ moneyFormat(paymentRequestDetail.amount) }}
            </span>
          </div>
          <div class="flex flex-wrap items-center justify-between wrap-span">
            <label class="lg:w-1/2 md:w-auto w-max">Request type</label>
            <span class="font-bold lg:w-1/2 md:w-auto w-max">
              {{
                paymentRequestDetail.requestType
                  ? paymentRequestDetail.requestType
                  : "one-off" | capitalize
              }}
            </span>
          </div>
          <div class="flex flex-wrap items-center justify-between wrap-span">
            <label class="lg:w-1/2 md:w-auto w-max">Account</label>
            <span class="font-bold lg:w-1/2 md:w-auto w-max">
              {{
                paymentRequestDetail.bank
                  ? paymentRequestDetail.bank.accountName
                  : "-"
              }}
            </span>
          </div>
        </vs-col>
        <vs-col vs-w="3" vs-lg="3" vs-md="3" vs-sm="5" vs-xs="12">
          <div class="flex flex-wrap items-center justify-between wrap-span">
            <label class="lg:w-1/2 md:w-auto w-max">Request sent</label>
            <span class="font-bold lg:w-1/2 md:w-auto w-max">
              {{ moment(paymentRequestDetail.createdAt) }}
            </span>
          </div>
          <div class="flex flex-wrap items-center justify-between wrap-span">
            <label class="lg:w-1/2 md:w-auto w-max">Status</label>
            <span class="font-bold lg:w-1/2 md:w-auto w-max">
              {{ paymentRequestDetail.paymentStatus }}
            </span>
          </div>
        </vs-col>
      </vs-row>
    </vx-card>

    <vx-card class="mt-10 lg:p-5 md:p5 p-3 trans-page">
      <h4 class="font-bold">Transaction linked to this payment request</h4>
      <vs-table
        v-if="paymentRequestDetail"
        :data="paymentRequestDetail.transactions"
        :max-items="10"
      >
        <template slot="thead">
          <vs-th>
            Date
          </vs-th>

          <vs-th>
            Transaction reference
          </vs-th>
          <vs-th>
            Amount
          </vs-th>

          <vs-th>
            Status
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.createdAt">
              {{ moment(tr.createdAt) }}
            </vs-td>
            <vs-td :data="tr.transactionID">
              {{ tr.transactionID }}
            </vs-td>
            <vs-td :data="tr.amount">
              {{ moneyFormat(tr.amount) }}
            </vs-td>
            <vs-td :data="tr.payeeName">
              {{ (tr.paymentStatus === 'Refunded')? ((tr.refundedByUser.length > 0)? 'Refunded By '+tr.refundedByUser[0].fullName :'Refunded'): tr.paymentStatus }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      paymentTransactions: [],
      paymentRequestDetail: ""
    };
  },
  methods: {
    ...mapActions("paymentRequest", ["fetchPaymentRequestDetailById"]),
    async fetchDetail(id) {
      await this.fetchPaymentRequestDetailById(id).then(result => {
        this.paymentRequestDetail = result.data.data;
      });
    },
    moment(date) {
      return moment(date).format("DD-MMM-YYYY");
    },
    moneyFormat(data) {
      return `$ ${parseFloat(data)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
    }
  },
  mounted() {
    this.fetchDetail(this.$route.params.id);
  }
};
</script>
